import React, { lazy, Suspense } from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { LoggedInRouter } from '@bbkAdminRouter/logged-in.router';
import { LeftColumn } from '@bbkAdminComponents/app-layout/left-column';
import { usePageTitle } from '@bbkShared/utils/page-title';
import './app-root.scss';
import './styles/layout.scss';
import { EndOfPlanBanner } from '@bbkAdminComponents/settings/plans/end-of-plan-banner';
import { StarterUpgradeBanner } from '@bbkAdminComponents/settings/plans/starter-upgrade-banner';
import { GetStartedBanner } from '@bbkAdminComponents/settings/plans/get-started-banner';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { defaultMUiTheme } from '@bbkShared/material-ui-theme';
import { FeatureFlagsE, useFeatureFlags } from '@bbkAdminUtils/feature-flags';

const LeftColumnV2 = lazy(
  () => import('@bbkAdminComponents/app-layout/left-column-v2')
);

export const AppRoot: React.FC = () => {
  usePageTitle();
  const theme = createTheme(defaultMUiTheme);
  const showCBNavbar = useFeatureFlags(FeatureFlagsE.ENABLE_STING_NAVBAR);
  return (
    <div className="tw-box-border" id="bbk-app-root">
      <ThemeProvider theme={theme}>
        <div
          className={cs('tw-flex tw-flex-col', 'tw-h-screen tw-max-h-screen')}
        >
          <GetStartedBanner />
          <StarterUpgradeBanner />
          <EndOfPlanBanner />
          <div className="bbk-layout column-layout">
            {showCBNavbar ? (
              <Suspense>
                <LeftColumnV2 />
              </Suspense>
            ) : (
              <LeftColumn />
            )}
            <LoggedInRouter />
          </div>
        </div>
      </ThemeProvider>

      {/* For when needed in a component */}
      <div id="chartjs-portal" />
    </div>
  );
};
